import { TrendUserIdentity } from "@/config/types/trend";
import "./AuthedIcon.less";

interface AuthedIconProps {
  userIdentity: TrendUserIdentity; // 个人认证还是机构认证
  type?: "big" | "small"; // 大图标还是小图标（个人认证时使用）
  level?: string; // 等级（个人认证时使用）
}

/**
 * 伯乐的标志
 */
const AuthedIcon = ({ userIdentity, type = "small", level = "1" }: AuthedIconProps) => {
  if (userIdentity === TrendUserIdentity.COMPANY) {
    return <i className="icon-authed icon-company-authed"></i>;
  }
  return <i className={`icon-authed icon-personal-authed ${type}-level${level}`}></i>;
};
export default AuthedIcon;
